import type { UrlObject } from 'url'

import { useCallback } from 'react'
import { useRouter } from 'next/router'

type QueryChange = string | number | null | undefined

/** Builds a link to the current page with some query values changed or removed. */
export const useQueryHref = (): ((changes: Record<string, QueryChange>) => UrlObject) => {
    const router = useRouter()
    const { pathname, query } = router

    return useCallback((changes: Record<string, QueryChange>) => {
        const next: Record<string, string> = {}

        for (const [key, value] of Object.entries(query)) {
            if (typeof value === 'string' && value !== '') next[key] = value
        }

        for (const [key, value] of Object.entries(changes)) {
            if (value === null || value === undefined || value === '') delete next[key]
            else next[key] = String(value)
        }

        return { pathname, query: next }
    }, [pathname, query])
}
